import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { brand, navLinks } from "../mock";

const Navbar = ({ onEnquire }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#f8f2e8]/95 backdrop-blur shadow-[0_4px_18px_rgba(31,58,42,0.08)]" : "bg-[#f8f2e8]/80"
      }`}
    >
      <div className="max-w-[1320px] mx-auto px-5 lg:px-8 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 shrink-0">
          <img src={brand.greatValueLogo} alt="Great Value" className="h-9 md:h-10 object-contain" />
          <div className="w-px h-7 bg-[#c26a4a]/40 hidden sm:block" />
          <img src={brand.yatharthLogo} alt="Yatharth" className="h-8 md:h-9 object-contain hidden sm:block" />
        </div>

        <nav className="hidden xl:flex items-center gap-5 flex-1 justify-center">
          {navLinks.map((l) => (
            <a key={l.label} href={l.href} className="nav-link whitespace-nowrap">{l.label}</a>
          ))}
        </nav>

        <div className="flex items-center gap-3 shrink-0">
          <button onClick={onEnquire} className="btn-gold hidden md:inline-flex whitespace-nowrap">ENQUIRE NOW</button>
          <button className="xl:hidden text-[#2a3d5c]" onClick={() => setOpen(!open)} aria-label="menu">
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="xl:hidden bg-[#f8f2e8] border-t border-[#c26a4a]/20 px-6 py-4">
          <div className="flex flex-col gap-3">
            {navLinks.map((l) => (
              <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="nav-link py-1">{l.label}</a>
            ))}
            <button onClick={() => { setOpen(false); onEnquire(); }} className="btn-gold mt-2 w-fit">ENQUIRE NOW</button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
